import { jsx as n } from "react/jsx-runtime";
import o from "react";
import { u as c } from "./index-6a632112.mjs";
import { Q as k, s as i, l as S, r as E, B as I } from "./themes-5f0b3c3d.mjs";
import { l as B } from "./lineHeights-72d3110c.mjs";
import { t as w } from "./textStyles-42cab346.mjs";
import { z as C } from "./zIndices-d07533f3.mjs";
import { S as A, a as H } from "./oldPlay-2e470880.mjs";
import { IconButton as L } from "./iconButton.js";
import { useWindowDimensions as W } from "./useWindowDimensions.js";
import "./fontWeights-a25f8f91.mjs";
import "./types-b577bf77.mjs";
import "./button.js";
import "./accessibility.js";
const F = "50%", R = "70%", T = c.div`
  align-items: center;
  display: flex;
  position: relative;
  aspect-ratio: 16/9;

  ${(e) => {
  switch (e.$contentAlignment) {
    case "center":
      return `
        justify-content: center;
        `;
    case "right":
      return `
          justify-content: flex-end;
        `;
    case "left":
    default:
      return `
        justify-content: flex-start;
        `;
  }
}}

  @media ${k.tabletAndUp} {
    aspect-ratio: 32/9;
  }
`, j = c.div`
  position: relative;
  z-index: ${C.contentOverVideo};
  margin-left: ${i["6x"]};
  margin-right: ${i["6x"]};
  letter-spacing: ${S[0]};

  ${(e) => {
  switch (e.$contentAlignment) {
    case "center":
      return `
          text-align: center;
        `;
    case "right":
      return `
          text-align: right;
        `;
    case "left":
    default:
      return `
          text-align: left;
        `;
  }
}}

  @media ${k.laptopAndUp} {
    ${(e) => {
  switch (e.$contentAlignment) {
    case "center":
      return `
          margin-right: auto;
          margin-left: auto;
        `;
    case "right":
      return `
          margin-right: ${i["12x"]};
        `;
    case "left":
    default:
      return `
          margin-left: ${i["12x"]}
        `;
  }
}}
  }
`, U = c.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: ${(e) => e.theme.components.landingHeroVideo.videoBackground};
  border-radius: ${E["1x"]};
`, _ = c.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: transparent;
  z-index: ${C.contentOverVideo - 1};
  background: ${(e) => e.theme.components.landingHeroVideo.videoBackground};

  ${(e) => e.$isPlaying ? `opacity: ${e.$playingOpacity};` : `opacity: ${e.$pausedOpacity};`}
`, D = c.div`
  height: 100%;
  width: 100%;

  div,
  video {
    position: relative;
    min-height: 100%;
    width: 100%;
    max-width: none;
    -o-object-fit: cover;
    object-fit: cover;
    z-index: ${C.contentOverVideo - 3};
  }
`, M = c.h1`
  && {
    color: ${(e) => e.theme.components.landingHeroVideo.textColor};
    font-family: FordMotion;
    font-weight: ${w.headline.xxl.fontWeight};
    font-size: ${w.headline.xxl.fontSize};
    line-height: ${B.xxxlarge};
    letter-spacing: ${S[0]};
    margin: 0 0 ${i["15x"]};
  }
`, Y = c.div`
  z-index: ${C.contentOverVideo};
  position: absolute;
  bottom: ${i["6x"]};

  ${(e) => {
  switch (e.$buttonAlignment) {
    case "right":
      return `right: ${i["6x"]};`;
    case "left":
    default:
      return `left: ${i["6x"]};`;
  }
}}

  @media ${k.laptopAndUp} {
    bottom: ${i["8x"]};

    ${(e) => {
  switch (e.$buttonAlignment) {
    case "right":
      return `right: ${i["12x"]};`;
    case "left":
    default:
      return `left: ${i["12x"]};`;
  }
}}
  }
`;
function N({ children: e, ...t }) {
  return /* @__PURE__ */ n(U, { ...t, children: e });
}
function Q({ children: e, ...t }) {
  const { contentAlignment: r } = o.useContext($);
  return /* @__PURE__ */ n(
    j,
    {
      $contentAlignment: r,
      ...t,
      children: e
    }
  );
}
function G({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ n(M, { ...t, children: e });
}
function K({
  children: e,
  onClick: t,
  size: r = "medium",
  buttonAlignment: a,
  ...s
}) {
  const { isPlaying: u, playbackIcon: d, handleOnClick: p, playButtonSize: l } = o.useContext($);
  function h(f) {
    p(), t?.(f, !u);
  }
  return /* @__PURE__ */ n(Y, { $buttonAlignment: a, ...s, children: /* @__PURE__ */ n(
    L,
    {
      icon: d,
      onClick: h,
      size: r || l
    }
  ) });
}
function q({
  videoProps: e,
  onPlay: t,
  onPause: r,
  onEnded: a,
  loopAmount: s = 0,
  pauseTime: u = -1,
  ...d
}) {
  const { defaultVideoProps: p, loopCount: l, setLoopCountFunc: h } = o.useContext($), {
    onPlay: f,
    onPause: y,
    loop: V,
    ref: x,
    ...b
  } = p, m = Math.floor(s);
  function O() {
    f(), t?.();
  }
  function P() {
    y(), r?.();
  }
  function z() {
    if (m > 0) {
      const v = x?.current;
      l + 1 < m ? (h(l + 1), v.currentTime = 0, v.play()) : (u >= 0 && (v.currentTime = u), v.pause());
    }
    a?.();
  }
  return /* @__PURE__ */ n(D, { ...d, children: /* @__PURE__ */ n(
    "video",
    {
      ...b,
      loop: m > 0 ? !1 : V,
      ...e,
      onPlay: O,
      onPause: P,
      onEnded: z,
      ref: x
    }
  ) });
}
function J({
  playingOpacity: e = F,
  pausedOpacity: t = R,
  ...r
}) {
  const { isPlaying: a } = o.useContext($);
  return /* @__PURE__ */ n(
    _,
    {
      $playingOpacity: e,
      $pausedOpacity: t,
      $isPlaying: a,
      ...r
    }
  );
}
const $ = o.createContext({
  defaultVideoProps: {
    loop: !0,
    ref: void 0,
    onPlay: () => {
    },
    onPause: () => {
    }
  },
  isPlaying: !1,
  playbackIcon: /* @__PURE__ */ n(A, {}),
  playButtonSize: "medium",
  handleOnClick: () => {
  },
  contentAlignment: "left",
  loopCount: 0,
  setLoopCountFunc: (e) => {
  }
});
function g({
  children: e,
  contentAlignment: t = "left",
  ...r
}) {
  const [a, s] = o.useState("medium"), [u, d] = o.useState(/* @__PURE__ */ n(A, {})), [p, l] = o.useState(!1), [h, f] = o.useState(0), y = o.useRef(null);
  function V() {
    d(/* @__PURE__ */ n(A, {})), l(!1);
  }
  function x() {
    d(/* @__PURE__ */ n(H, {})), l(!0);
  }
  function b() {
    const P = y?.current;
    p ? P.pause() : (f(0), P.play());
  }
  const { width: m } = W();
  o.useEffect(() => {
    m < I.laptopMin ? s("medium") : s("large");
  }, [m]);
  const O = {
    playsInline: !0,
    autoPlay: !0,
    muted: !0,
    loop: !0,
    onPlay: x,
    onPause: V,
    ref: y,
    role: "video"
  };
  return /* @__PURE__ */ n(T, { $contentAlignment: t, ...r, children: /* @__PURE__ */ n(
    $.Provider,
    {
      value: {
        defaultVideoProps: O,
        isPlaying: p,
        handleOnClick: b,
        playbackIcon: u,
        playButtonSize: a,
        contentAlignment: t,
        loopCount: h,
        setLoopCountFunc: f
      },
      children: e
    }
  ) });
}
g.HeaderContainer = Q;
g.VideoContainer = N;
g.Title = G;
g.PlaybackButton = K;
g.VideoElement = q;
g.Overlay = J;
export {
  g as LandingHeroVideo
};
